<template>
  <a-modal
    title="库存调整"
    :width="1080"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok', this.otherData) }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="仓库">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="warehouseFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'warehouse_id',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请输入仓库"
                :default-active-first-option="false"
                @search="this.warehouseSearch"
                @change="handleWarehouseChange"
              >
                <a-spin v-if="warehouseFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in warehouseList" :key="d.id" :tt="d.name">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="单位" >
              <a-select
                v-decorator="[
                  'unit',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.unit">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="数量">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['count', {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
            <a-form-item label="预估人民币价格">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['unit_price_cny', {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
            <a-form-item label="开启审批">
              <a-switch v-decorator="['is_approval_needed', { initialValue: false, valuePropName: 'checked' }]" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="附件">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
              <a-table bordered :data-source="attachmentList" :columns="attachmentColumns" v-if="this.attachmentList.length > 0" :pagination="false">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="attachmentList.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <attachment-create-form
        ref="attachmentCreateForm"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="mdl" />
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import { warehouse_list } from '@/api/trade_warehouse'
import AttachmentCreateForm from '../attachment/modules/CreateForm'

// 表单字段
const fields = ['id', 'name', 'code']
export default {
  components: {
    AttachmentCreateForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    this.warehouseSearch = debounce(this.handleWarehouseSearch, 800)
    return {
      form: this.$form.createForm(this),
      warehouseList: [],
      unit: this.$Dictionaries.unit,
      otherData: {
        attachment: []
      },
      visibleFrom: false,
      confirmLoadingFrom: false,
      warehouseFetching: false,
      mdl: {},
      attachmentList: [],
      attachmentColumns: [
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  methods: {
    handleWarehouseSearch (value) {
      this.warehouseFetching = true
      this.warehouseList = []
      warehouse_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.warehouseList = result
      }).finally(() => {
        this.warehouseFetching = false
      })
    },
    handleWarehouseChange (value) {
      console.log(value)
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleAddAttachment () {
      this.visibleFrom = true
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.attachmentList]
      this.attachmentList = dataSource.filter(item => item.key !== key)
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (date) {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          values.url = values.url.fileList[0].url
          this.attachmentList.push(values)
          this.visibleFrom = false
          this.otherData.attachment = this.attachmentList
          form.resetFields()
        }
      })
    }
  }
}
</script>
